<template>
  <cTable
    ref="table"
    :config="config"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #IMAGE="{row}">
      <img
        @click="preview(row.img_link)"
        style="height:60px;"
        v-if="row && row.img_link"
        :src="row.img_link"
      />
    </template>
    <template #PREVIEW="{params,visible}">
      <img style="width: 100%;" v-if="visible" :src="params.src" />
    </template>
  </cTable>
</template>

<script>
import {
  add,
  getSku,
  getDetails,
  update,
  del,
  getBarcode,
  uploadFlieSku
} from "@/api/storage/sku";
import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
export default {
  name: "goodsSku",
  components: {
    cTable
  },
  data() {
    let isNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Cannot be empty"));
      }
      this.$nextTick(() => {
        var reg = new RegExp(/^[+-]?(0|([1-9]\d*))(\.\d+)?$/);
        if (!reg.test(value)) {
          callback(new Error("Must be a number"));
        } else {
          if (value < 0.0001) {
            callback(new Error("Must be greater than 0.0001"));
          } else if (value > 9999.9999) {
            callback(new Error("Must be less than 9999.9999"));
          } else {
            callback();
          }
        }
      });
    };
    return {
      config: {
        // showOverflow: false
      },
      methods: {
        list: getSku,
        getDetails,
        update,
        del,
        getBarcode,
        uploadFlieSku,
        getAllClient,
        add
      },
      modals: {
        preview: {
          config: {
            title: this.$t("preview")
          },
          contentSlot: "PREVIEW",
          footer: {
            show: false
          }
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "40%"
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  type: "number",
                  message: "client cannot be empty",
                  trigger: "blur"
                }
              ],
              sku_code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              sku_name: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 155,
                  message: "Please enter maximum length 155",
                  trigger: "blur"
                }
              ],
              sku_title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 155,
                  message: "Please enter maximum length 155",
                  trigger: "blur"
                }
              ],
              weight: [{ required: true, type: "number", trigger: "blur" }],
              width: [{ required: true, type: "number", trigger: "blur" }],
              height: [{ required: true, type: "number", trigger: "blur" }],
              length: [{ required: true, type: "number", trigger: "blur" }],
              declaration_amount: [
                { required: true, type: "number", trigger: "blur" }
              ],
              hs_code: [
                {
                  required: true,
                  message: "hs_code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              bar_code: [
                {
                  required: true,
                  message: "bar_code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { sku_name: 24 },
            { sku_title: 24 },
            { client_id: 24 },
            { weight: 24 },
            { width: 24 },
            { height: 24 },
            { length: 24 },
            { declaration_amount: 24 },
            { hs_code: 24 },
            { bar_code: 24 },
            { aliexpress_code: 24 }
          ],
          fields: [
            {
              key: "sku_name",
              name: () => this.$t("skuName1"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("skuName1");
              }
            },
            {
              key: "sku_title",
              name: () => this.$t("skuTitle"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("skuTitle");
              }
            },
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              component: "Select",
              config: {
                label: "account",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAllClient")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "weight",
              name: () => this.$t("skuWeight"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 0
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("skuWeight");
              }
            },
            {
              key: "width",
              name: () => this.$t("skuWidth"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 0
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("skuWidth");
              }
            },
            {
              key: "height",
              name: () => this.$t("skuHeight"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 0
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("skuHeight");
              }
            },
            {
              key: "length",
              name: () => this.$t("skuLength"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 0
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("skuLength");
              }
            },
            {
              key: "declaration_amount",
              name: () => this.$t("skuAmount"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
                min: 0
              },
              default: null,
              placeholder() {
                return this.$t("enter") + this.$t("skuAmount");
              }
            },
            {
              key: "hs_code",
              name: () => this.$t("hsCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("hsCode");
              }
            },
            {
              key: "bar_code",
              name: () => this.$t("barCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("barCode");
              },
              disabled: row => {
                return row.formData.id && row.formData.bar_code ? true : false;
              }
            },
            {
              key: "aliexpress_code",
              name: () => this.$t("aliexpressCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("aliexpressCode");
              }
            }
          ]
        },
        upload: {
          config: {
            modalBind: {
              width: "80%"
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            title: "uploadRes"
          },
          footer: {
            show: false
          },
          table: {
            config: {
              align: "center",
              height: 400
            },
            fields: [
              {
                name: () => this.$t("skuName1"),
                key: "sku_name",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("msg"),
                key: "msg",
                align: "center",
                minWidth: 180
              },
              {
                name: () => this.$t("skuTitle"),
                key: "sku_title",
                align: "center",
                minWidth: 125
              },
              {
                name: () => this.$t("skuWeight"),
                key: "weight",
                align: "center",
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return parseFloat(value).toFixed(2);
                  }
                }
              },
              {
                name: () => this.$t("skuVolume"),
                key: "volume",
                align: "center",
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return parseFloat(value).toFixed(2);
                  }
                }
              },
              {
                name: () => this.$t("skuWidth"),
                key: "width",
                align: "center",
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return parseFloat(value).toFixed(2);
                  }
                }
              },
              {
                name: () => this.$t("skuHeight"),
                key: "height",
                align: "center",
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return parseFloat(value).toFixed(2);
                  }
                }
              },
              {
                name: () => this.$t("skuLength"),
                key: "length",
                align: "center",
                minWidth: 95
              },
              {
                name: () => this.$t("skuAmount"),
                key: "declaration_amount",
                align: "center",
                minWidth: 95
              },
              {
                name: () => this.$t("hsCode"),
                key: "hs_code",
                align: "center",
                minWidth: 95
              },
              {
                name: () => this.$t("barCode"),
                key: "bar_code",
                align: "center",
                minWidth: 95
              },
              {
                name: () => this.$t("aliexpressCode"),
                key: "aliexpress_code",
                align: "center",
                minWidth: 95
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "client_id",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              id: 686,
              bind: {
                icon: "md-add",
                type: "success"
              }
            },
            {
              name: () => this.$t("updateFile"),
              type: "import",
              fnName: "importFun",
              id: 683,
              disabled: row => {
                return row.searchForm.client_id ? false : true;
              },
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning"
              }
            },
            {
              name: () => this.$t("download_tem"),
              type: "download",
              fnName: "download",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("export") + this.$t("barCode"),
              type: "barCode",
              fnName: "exBarCode",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "success"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            },
            export() {
              console.log("cs", this);
              this.exportExc();
            },
            importFun({ file, searchForm }) {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("client_id", searchForm.client_id);
              this.$page
                .handleRequestMethods("uploadFlieSku", formData, true)
                .then(res => {
                  console.log("res", res);
                  this.$page.getModal("upload").open({}, function() {
                    this.list = res.payload;
                  });
                  this.$page.getList();
                });
              return false;
            },
            download() {
              window.open(
                this.$globalUrl + "/static/templates/uploadGoods.xls"
              );
            },
            exBarCode() {
              let data = this.selectAll.map(item => {
                return item.bar_code;
              });
              this.handleRequestMethods(
                "getBarcode",
                { hs_code: data },
                true,
                true
              ).then(res => {
                window.open(this.$globalUrl + "/" + res.payload);
              });
            }
          }
        }
      },
      fields: [
        // {
        //   type:'btns',
        //   width:200,
        //   name:'功能',
        //   fixed:'right',
        //   width({field}){
        //     return field.list.length * 40 + 40
        //   },
        //   list:[
        //     {
        //       name:'删除',
        //       type:'delete',
        //     },
        //     {
        //       name:'禁用',
        //       type:'diabled',
        //     }
        //   ],
        //   methods:{
        //     click({row}){
        //       console.log('click',row,this);
        //     }
        //   }
        // },
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        // {
        //   name:'序号',
        //   type:'seq',
        //   align: "center",
        //   width:50,
        // },
        {
          name: () => this.$t("skuName1"),
          key: "sku_name",
          align: "left",
          minWidth: 100,
          slot: "TEST"
        },
        {
          name: () => this.$t("skuTitle"),
          key: "sku_title",
          align: "left",
          tooltip: true,
          minWidth: 125
        },
        {
          name: () => this.$t("photo"),
          key: "img_link",
          align: "center",
          width: 160,
          slot: "IMAGE"
        },
        {
          name: () => this.$t("clientName"),
          key: "customer",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.customer ? row.customer.account : "";
            }
          }
        },
        {
          name: () => this.$t("skuWeight"),
          key: "weight",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render({ row }) {
              return this.toFixed(row.weight);
            }
          }
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render({ row }) {
              return this.toFixed(row.volume);
            }
          }
        },
        {
          name: () => this.$t("skuWidth"),
          key: "width",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render({ row }) {
              return this.toFixed(row.width);
            }
          }
        },
        {
          name: () => this.$t("skuHeight"),
          key: "height",
          align: "center",
          tooltip: true,
          minWidth: 100,
          methods: {
            render({ row }) {
              return this.toFixed(row.height);
            }
          }
        },
        {
          name: () => this.$t("skuLength"),
          key: "length",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("skuAmount"),
          key: "declaration_amount",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("hsCode"),
          key: "hs_code",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("barCode"),
          key: "bar_code",
          align: "center",
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          // tooltip: false,
					copy:true,
					header:{
						copy:true
					},
          width: 180,
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods("getBarcode", {
                  hs_code: row.bar_code
                })
                .then(res => {
                  window.open(this.$globalUrl + "/" + res.payload);
                });
            }
          }
        },
        {
          name: () => this.$t("aliexpressCode"),
          key: "aliexpress_code",
          align: "center",
          minWidth: 100
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              id: 685,
              bind: {
                type: "success"
              }
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 684,
              bind: {
                type: "error"
              }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("barCode") +
                  "：" +
                  row.bar_code +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  methods: {
    preview(src) {
      this.$refs["table"].getModal("preview").open({ src });
    }
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
    });
  }
};
</script>

<style lang="scss" scoped></style>
